import type { FormFields } from '@/entities/purchase-form';

type BuildLineLabel = {
    type: string;
    name: 'FRONT' | 'BACK';
    lines: FormFields['personalization']['frontLines'];
};

export const buildLineLabel = ({ type, name, lines = [] }: BuildLineLabel) =>
    lines?.map(line => `${type} Text (${name}) Line ${line.order} (Max ${line.max})`).join('|');
